export default __webpack_public_path__ + "static/media/18.01ade581.png";